import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Video, PhoneOff, Phone, Users } from "lucide-react";
import { Avatar } from "@/components/Avatar";
import { useRingtone } from "@/hooks/useRingtone";

const RING_TIMEOUT = 30000;

export default function IncomingCallModal({ call, onAccept, onDecline, onTimeout }) {
  useRingtone(!!call);

  useEffect(() => {
    if (!call) return;
    const t = setTimeout(() => onTimeout?.(), RING_TIMEOUT);
    return () => clearTimeout(t);
  }, [call, onTimeout]);

  if (!call) return null;
  return (
    <div data-testid="incoming-call-modal" className="fixed inset-0 z-[115] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4">
      <motion.div
        initial={{ scale: 0.9, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        className="bg-card border-2 border-[#6C0BA9] rounded-3xl p-7 w-full max-w-xs text-center shadow-2xl"
      >
        <div className="relative mx-auto w-20 h-20 mb-4">
          <div className="absolute inset-0 rounded-full bg-[#6C0BA9] opacity-40 blur-xl x-pulse" />
          <div className="relative"><Avatar user={call.caller} size={80} /></div>
        </div>
        <h2 className="font-heading text-xl font-extrabold">{call.caller?.name}</h2>
        <p className="text-sm text-muted-foreground mt-1 flex items-center justify-center gap-1.5">
          {call.kind === "group" ? <><Users className="w-4 h-4" />Group call · {call.title}</> : <><Video className="w-4 h-4" />Incoming video call</>}
        </p>
        <div className="flex items-center justify-center gap-6 mt-7">
          <button data-testid="decline-call-btn" onClick={onDecline} className="flex flex-col items-center gap-1.5">
            <span className="w-14 h-14 rounded-full bg-red-500 hover:bg-red-600 text-white flex items-center justify-center transition-colors"><PhoneOff className="w-6 h-6" /></span>
            <span className="text-xs text-muted-foreground">Decline</span>
          </button>
          <button data-testid="accept-call-btn" onClick={onAccept} className="flex flex-col items-center gap-1.5">
            <span className="w-14 h-14 rounded-full bg-green-500 hover:bg-green-600 text-white flex items-center justify-center transition-colors x-pulse"><Phone className="w-6 h-6" /></span>
            <span className="text-xs text-muted-foreground">Accept</span>
          </button>
        </div>
      </motion.div>
    </div>
  );
}
